module.exports = __webpack_public_path__ + "images/kihnu/apple-icon-180x180.png";